<template lang="pug">
  section
    b-container(v-if="shipment")
      h1.mt-0 {{ `Shipment #${shipment.id}` }}
      .breadcrumbs.text-muted.small.py-3
        router-link(:to="{name: 'Shipments', query: { order: shipment.customer_order_id } }")
          font-awesome-icon.mr-2(icon="chevron-left")
          span Back to Shipments
      .row
        .col-12
          b-card.mt-3
            .container
              .row
                .col-6
                  h4 Summary
                  p Details
                  ul.list-unstyled
                    li
                      span.font-weight-bold Shipment
                      span.ml-1 {{ `#${shipment.id}` }}
                    li.pb-3
                      span.font-weight-bold Status
                      b-badge.ml-2(variant="dark") {{ shipment.status || 'unpaid' }}
                    li.pb-3
                      span.font-weight-bold Track
                      a.ml-1(:href="`https://portal.thecourierguy.co.za/track?ref=${shipment.tracking_number}`") {{ shipment.tracking_number }}
                .col-md-6
                  h4 Actions
                  content-loader(:height="2", v-if="alert.busy")
                  div(v-else="")
                    p Please select
                    ul(v-if="shipment.status !== 'cancelled'")
                      li
                        a(@click="editShipment = !editShipment") Update Address
                      li
                        a(@click="cancelShipment()") Cancel Shipment
                    span(v-else="") Shipment cancelled
        .col-12
          b-card.mt-3
            .container
              h4 Address
              form.mt-3(@submit.prevent='onSubmit', :disabled="true")
              .row(v-if="shipment.artist && shipment.customer")
                .col-6
                  p From
                  p.m-0 {{ shipment.artist.name }}
                  p.m-0 {{ shipment.artist.phone }}
                  p {{ shipment.artist.email }}
                  div(v-if="!editShipment")
                    p.m-0 {{ shipment.address_origin.line_1 }}
                    p.m-0 {{ shipment.address_origin.line_2 }}
                    p.m-0 {{ shipment.address_origin.city }}
                    p.m-0 {{ shipment.address_origin.province }}
                    p.m-0 {{ shipment.address_origin.suburb }}
                    p.m-0 {{ shipment.address_origin.zip }}
                  .row(v-else="")
                    .col-md-6
                      b-form-group
                        label STREET ADDRESS
                        b-form-input(type='text', maxlength="60", v-model='shipment.address_origin.line_1', required='')
                    .col-md-6
                      b-form-group
                        label.d-inline APARTMENT
                        b-form-input(type='text', minlength="5", maxlength="60", v-model='shipment.address_origin.line_2')
                    .col-md-6
                      b-form-group
                        label CITY
                        b-form-input(type='text', maxlength="60", v-model='shipment.address_origin.city', required='')
                    .col-md-6
                      b-form-group
                        label PROVINCE
                        b-form-select(:options="provinces", v-model='shipment.address_origin.province', required='')
                    .col-md-6
                      b-form-group
                        label ZIP
                        b-form-input(type='number', v-model='shipment.address_origin.zip', required='')
                    .col-md-6
                      b-form-group
                        label SUBURB
                        b-form-input(type='text', maxlength="60", v-model='shipment.address_origin.suburb', required='')
                .col-6
                  p To
                  p.m-0 {{ shipment.customer.name }}
                  p.m-0 {{ shipment.customer.phone }}
                  p {{ shipment.customer.email }}
                  div(v-if="!editShipment")
                    p.m-0 {{ shipment.address_destination.line_1 }}
                    p.m-0 {{ shipment.address_destination.line_2 }}
                    p.m-0 {{ shipment.address_destination.city }}
                    p.m-0 {{ shipment.address_destination.province }}
                    p.m-0 {{ shipment.address_destination.suburb }}
                    p.m-0 {{ shipment.address_destination.zip }}
                  .row(v-else="")
                    .col-md-6
                      b-form-group
                        label STREET ADDRESS
                        b-form-input(type='text', maxlength="60", v-model='shipment.address_destination.line_1', required='')
                    .col-md-6
                      b-form-group
                        label.d-inline APARTMENT
                        b-form-input(type='text', minlength="5", maxlength="60", v-model='shipment.address_destination.line_2')
                    .col-md-6
                      b-form-group
                        label CITY
                        b-form-input(type='text', maxlength="60", v-model='shipment.address_destination.city', required='')
                    .col-md-6
                      b-form-group
                        label PROVINCE
                        b-form-select(:options="provinces", v-model='shipment.address_destination.province', required='')
                    .col-md-6
                      b-form-group
                        label ZIP
                        b-form-input(type='number', v-model='shipment.address_destination.zip', required='')
                    .col-md-6
                      b-form-group
                        label SUBURB
                        b-form-input(type='text', maxlength="60", v-model='shipment.address_destination.suburb', required='')
                    .col-12.text-right
                      b-form-group
                        button-load(:flag="alert.busy", label="Update", classes="btn-outline", v-on:clicked="updateShipment")
        .col-md-6
          b-card.table-card.mt-3
            .container
              h4 Items
              b-table(:items="shipment.items", :fields="fields", sort-icon-left, sort-by="id", :sort-desc="true", responsive, borderless)
                  template(v-slot:cell(compTitle)="row")
    b-container(v-else="")
      content-loader(:height="7")
</template>

<script>

import { apiService } from '@/services';
import standardMix from '@/mixins/standardMix';

export default {
  name: 'Shipment',
  mixins: [standardMix],
  data() {
    return {
      shipment: null,
      editShipment: false,
      provinces: ['Eastern Cape', 'Free State', 'Gauteng', 'KwaZulu-Natal', 'Limpopo', 'Mpumalanga', 'Northern Cape', 'North West', 'Western Cape'],
      fields: [
        { key: 'product_title', label: 'Piece', sortable: true },
        // { key: 'compCommission', label: 'Commission' },
        // { key: 'compToArtist', label: 'To Artist' },
        // { key: 'compLineTotal', label: 'Line' },
        { key: 'quantity', label: 'Quantity' },
      ],
    };
  },
  computed: {
  },
  methods: {
    async updateShipment() {
      console.log('updateShipment', this.shipment);
      try {
        this.clear();
        this.busy();
        await apiService.updateShipment({
          id: this.shipment.id,
          address_origin: this.shipment.address_origin,
          address_destination: this.shipment.address_destination,
        });
        this.shipment = await apiService.getShipment(this.$route.params.shipmentId);
        this.editShipment = false;
        this.success('Shipment confirmed');
      } catch (error) {
        this.error(error);
      }
    },
    async cancelShipment() {
      try {
        this.clear();
        this.busy();
        this.shipment = await apiService.cancelShipment(this.shipment.id);
        // this.shipment = await apiService.getShipment(this.$route.params.shipmentId);
        this.success('Shipment cancelled');
      } catch (error) {
        this.error(error);
      }
    },
  },
  async created() {
    if (this.$route.params.shipmentId) {
      try {
        this.loading();
        this.shipment = await apiService.getShipment(this.$route.params.shipmentId);
        this.clear();
      } catch (error) {
        this.error('Shipment not found');
      }
    }
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Shipment.vue